export const isSameHour = (dateLeft, dateRigth) => dateLeft.getDate() === dateRigth.getDate()
  && dateLeft.getMonth() === dateRigth.getMonth()
  && dateLeft.getFullYear() === dateRigth.getFullYear()
  && dateLeft.getHours() === dateRigth.getHours();
